import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const AnalyticsBillsIndicatorsDashboardPage = lazyImport(
  () => import('~/views/analytics/bills-dashboard/AnalyticsBillsIndicatorsDashboardPage'),
);

const ClosingDetailsDashboardPage = lazyImport(
  () => import('~/views/analytics/bills-dashboard/pages/ClosingDetailsDashboardPage'),
);

const MonthlyDetailsDashboardPage = lazyImport(
  () => import('~/views/analytics/bills-dashboard/pages/MonthlyDetailsDashboardPage'),
);

const TaxableByDeviceChart = lazyImport(
  () => import('~/views/analytics/bills-dashboard/components/charts/taxable-by-device/TaxableByDeviceChart'),
);
const NonTaxableSalesChart = lazyImport(
  () => import('~/views/analytics/bills-dashboard/components/charts/non-taxable-sales/NonTaxableSalesChart'),
);
const PaymentMethodsChart = lazyImport(
  () => import('~/views/analytics/bills-dashboard/components/charts/payment-methods/PaymentMethodsChart'),
);
const AverageTicketChart = lazyImport(
  () => import('~/views/analytics/bills-dashboard/components/charts/average-ticket/AverageTicketChart'),
);

export const analyticsBillsDashboardPages: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={RouteConfig.AnalyticsBillsTaxableByDevice.buildLink()} replace />,
  },
  {
    element: <AnalyticsBillsIndicatorsDashboardPage />,
    children: [
      {
        path: 'indicators/taxable-by-device',
        element: <TaxableByDeviceChart />,
      },
      {
        path: 'indicators/non-taxable-sales',
        element: <NonTaxableSalesChart />,
      },
      {
        path: 'indicators/payment-methods',
        element: <PaymentMethodsChart />,
      },
      {
        path: 'indicators/average-ticket',
        element: <AverageTicketChart />,
      },
    ],
  },
  {
    path: 'closing-details',
    element: <ClosingDetailsDashboardPage />,
  },
  {
    path: 'monthly-details',
    element: <MonthlyDetailsDashboardPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.AnalyticsBillsTaxableByDevice.buildLink()} replace />,
  },
];
